import { COLORS } from '@/styles/colorTheme';
import { Container } from './Regular.styles';
import { useRef, useEffect, useState } from 'react';
import { cn } from '@/lib/utils';

const SecondaryTap = ({ isActive = false, children, color = COLORS.Text400, onClick }) => {
  const refEL = useRef<any>(null);
  const [isHover, setIsHover] = useState(false);

  useEffect(() => {
    const instance = refEL.current;

    instance.addEventListener('mouseover', () => {
      setIsHover(true);
    });

    instance.addEventListener('mouseleave', () => {
      setIsHover(false);
    });

    return () => {
      instance.removeEventListener('mouseover', () => {
        setIsHover(true);
      });

      instance.removeEventListener('mouseleave', () => {
        setIsHover(false);
      });
    };
  }, []);

  return (
    <Container ref={refEL} isActive={isActive} onClick={onClick}>
      <div
        className={cn(
          'truncate',
          isHover ? `text-[${color}]` : isActive ? 'text-white' : `text-[${color}]`,
        )}
      >
        {children}
      </div>
    </Container>
  );
};

export default SecondaryTap;
